module.exports = __webpack_public_path__ + "img/remove-on.9d54941e.svg";